export default __webpack_public_path__ + "static/Jabrille_Lotus_Trading-cca9c62daddcc1ec07df46e636bf7345.mp4";